<template>
	<div class="relative">

		<div class="vx-navbar-wrapper" :class="classObj">

			<vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon"
							  @click.stop="showSidebar" :class="textColor"/>

				<div class="the-navbar__user-meta flex items-center" v-if="authenticated && dashboard">
					<div class="leading-tight hidden sm:block">
						<small>Dashboard</small>
						<p class="font-semibold" v-if="dashboardList.length <= 1">
							{{ dashboard.name }}
						</p>

						<vue-multiselect
							v-else
							style="width: 300px"
							placeholder="Selecteer dashboard"
							v-model="selectedDashboard"
							:options="dashboardList"
							:show-labels="false"
							:allow-empty="false"
							track-by="name" label="name"
						/>
					</div>
				</div>

				<vs-spacer/>

				<!--<notification-drop-down/>-->

				<profile-drop-down/>

			</vs-navbar>
		</div>
	</div>
</template>
<script>
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
import {mapActions, mapGetters} from 'vuex';
import {da} from "date-fns/locale";

export default {
	name: 'the-navbar-vertical',
	props: {
		navbarColor: {
			type: String,
			default: '#fff'
		}
	},
	components: {
		NotificationDropDown,
		ProfileDropDown
	},
	data() {
		return {
			selectedDashboard: null,
			isProgrammaticUpdate: false,
		}
	},
	computed: {
		...mapGetters({
			authenticated: 'auth/authenticated',
			dashboard: 'dashboard/dashboard',
			dashboardList: 'dashboard/dashboardList',
		}),
		navbarColorLocal() {
			return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth
		},
		textColor() {
			// Get background color hex value. '#' is optional.
			let hex = (this.navbarColor.charAt(0) === '#') ? this.navbarColor.substring(1, 7) : this.navbarColor;

			// Convert 3-digit hex to 6-digits.
			if (hex.length === 3) {
				hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
			}

			// By this point, it should be 6 characters
			if (hex.length !== 6) {
				throw new Error('Invalid HEX color.');
			}

			const r = parseInt(hex.slice(0, 2), 16),
				g = parseInt(hex.slice(2, 4), 16),
				b = parseInt(hex.slice(4, 6), 16);

			// Return light or dark class based on contrast calculation
			// eslint-disable-next-line no-mixed-operators
			return ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? 'text-dark' : 'text-white';
		},
		windowWidth() {
			return this.$store.state.windowWidth
		},

		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
			else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
			else if (this.verticalNavMenuWidth) return 'navbar-full'
		}
	},
	watch: {
		'dashboardList'(newDashboardList) {
			this.isProgrammaticUpdate = true;

			newDashboardList.forEach((dashboard) => {
				if (dashboard.selected) {
					this.selectedDashboard = dashboard;
				}
			});

			this.$nextTick(() => {
				this.isProgrammaticUpdate = false;
			})
		},
		'selectedDashboard'(newSelectedDashboard) {
			if (this.isProgrammaticUpdate) return;

			console.log("newSelectedDashboard");
			console.log(newSelectedDashboard.id);

			this.changeSelectedDashboard(newSelectedDashboard.id).then(result => {
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je actieve dashboard is aangepast',
					color: 'success'
				});

				window.location.reload();
			}).catch(error => {
				this.$vs.notify({
					title: 'Error',
					text: 'Er is iets mis gegaan, probeer het opnieuw',
					color: 'danger'
				});
			});
		},
	},
	methods: {
		...mapActions({
			changeSelectedDashboard: "dashboard/changeSelectedDashboard"
		}),
		showSidebar() {
			this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
		}
	}
}
</script>

</file>
